import { Injectable } from '@angular/core';
import { ShippingTime } from '@app/models/shipping-time';
import { ApiService } from '@app/services/api/api.service';
import { FlashService } from '@app/services/flash.service';
import {
  AddAll,
  Export,
  Load,
  LoadFail,
  LoadSuccess,
  RefreshShippingTimes,
  ShippingTimeActionTypes,
  UploadSuccess
} from '@core/actions/shipping-time.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

@Injectable()
export class ShippingTimeEffects {
  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType<Load>(ShippingTimeActionTypes.Load),
    switchMap(() => {
      console.log("LOADDD")
      return this.api.getShippingTimes().pipe(
        map((shippingTimes: ShippingTime[]) => new LoadSuccess(shippingTimes)),
        catchError(error => of(new LoadFail(error)))
      );
    })
  );

  @Effect()
  loadSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<LoadSuccess>(ShippingTimeActionTypes.LoadSuccess),
    map(action => new AddAll(action.shippingTimes))
  );

  @Effect({ dispatch: false })
  proformaDownloabled$ = this.actions$.pipe(
    ofType<Export>(ShippingTimeActionTypes.Export),
    tap((action) =>
      this.api.downloadShippingTimes()
    )
  )
  
  @Effect({ dispatch: false })
  refreshShippingTimes$ = this.actions$.pipe(
    ofType<RefreshShippingTimes>(ShippingTimeActionTypes.RefreshShippingTimes),
    tap((action) =>
      this.api.refreshShippingTimes()
    )
  )

  @Effect({ dispatch: false })
	uploadSuccess$ = this.actions$.pipe(
		ofType<UploadSuccess>(ShippingTimeActionTypes.UploadSuccess),
		map(action => {
			this.fs.emit({ type: 'success', message: 'Destinos actualizados' });
			// return new Load();
		})
	);




  //   @Effect()
  //   create$: Observable<Action> = this.actions$.pipe(
  //     ofType<Create>(ShippingTimeActionTypes.Create),
  //     map(action => action.shippingTime),
  //     switchMap(shippingTime =>
  //       this.api.create(shippingTime).pipe(
  //         map((savedShippingTime: ShippingTime) => new CreateSuccess(savedShippingTime)),
  //         catchError(error => of(new CreateFail(error)))
  //       )
  //     )
  //   );

  //   @Effect()
  //   createSuccess$: Observable<Action> = this.actions$.pipe(
  //     ofType<CreateSuccess>(ShippingTimeActionTypes.CreateSuccess),
  //     map(action => {
  //       this.fs.emit({ type: 'success', message: 'Proveedor creado' });
  //       return new AddOne(action.shippingTime);
  //     })
  //   );

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private fs: FlashService
  ) {}
}
